import dayjs from 'dayjs';
import {tenant} from './tenant';

const checkAppEnv = () => {
    // 테넌트 우선: 등록 테넌트 도메인이면 그 테넌트의 값(qesg 도메인은 'supply' = 현행과 동일한 no-op).
    // 미등록 호스트/node 환경은 빌드 env 폴백. VUE_APP_CUSTOM_ENV 철거 후 tenant 가 단일 소스가 된다.
    return tenant?.legacyCustomEnv ?? process.env.VUE_APP_CUSTOM_ENV ?? null;
};
const waitTime = (time) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, time);
    });
};

const getDefaultPagination = (currentPage = 1, perPage = 10, totalRows = 0) => {
    return {
        currentPage: currentPage,
        perPage: perPage,
        totalRows: totalRows
    };
};

const getPerPageOptions = () => {
    return [
        { text: '10개', value: 10 },
        { text: '20개', value: 20 },
        { text: '30개', value: 30 },
        { text: '50개', value: 50 },
        { text: '100개', value: 100 },
        { text: '전체', value: null },
    ];
};

const getEmptyTableHTML = (text, height = '521px') => {
    return `<div class="text-center text-muted d-flex flex-column justify-content-center align-items-center" style="height: ${height};">
                <i class="bi bi-exclamation-circle-fill" style="font-size: 2rem;"></i>
                <h6 class="mt-3 gray-400">${text}</h6>
            </div>`;
};

const onTooltipShow = (bvEvent) => {
    const targetEl = bvEvent.target;
    
    const tooltip = bvEvent.vueTarget;
    if (!tooltip) return;
    
    const width = targetEl.offsetWidth;
    tooltip.offset = -(width / 2);
};

const getDate = (date) => {
    if (!date) return '';
    if(!dayjs(date).isValid()) return '잘못된 날짜 형식입니다.';
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
};



export {checkAppEnv,waitTime, getDefaultPagination, getPerPageOptions, getEmptyTableHTML, onTooltipShow, getDate};
